export const PreInvoicesUrl = `/preInvoices`;
export const PreInvoiceUrlPreInvoiceIdParam = 'preInvoiceId';
export const PreInvoiceUrlMapping = `${PreInvoicesUrl}/:${PreInvoiceUrlPreInvoiceIdParam}`;
export const preInvoiceUrl = (preInvoiceId: string) => `${PreInvoicesUrl}/${preInvoiceId}`;